import React from 'react';
import {
  Grid,
  Paper,
  Box,
  Typography,
  Chip,
  Button,
  Divider,
} from '@material-ui/core';
import {
  Storefront,
  EventNote,
  Receipt,
  ArrowForward,
} from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import { formattedCurrency } from '../../../utils/utils';

const OverviewLiveOperations = ({ liveOperations }) => {
  const history = useHistory();

  if (!liveOperations) return null;

  const {
    cashRegisters = [],
    todaySchedules = {},
    dueBills = {},
    recentSales = [],
  } = liveOperations;

  const scheduleItems = todaySchedules.nextItems || [];
  const billItems = dueBills.items || [];

  return (
    <Grid container spacing={3} style={{ marginBottom: 24 }}>
      {/* Coluna 1: Status dos Caixas */}
      <Grid item xs={12} md={4}>
        <Paper
          elevation={0}
          style={{
            padding: 20,
            borderRadius: 10,
            border: '1px solid #e2e8f0',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mb={1.5}
            >
              <Box display="flex" alignItems="center">
                <Storefront style={{ color: '#0284c7', marginRight: 8 }} />
                <Box>
                  <Typography
                    variant="h6"
                    style={{ fontWeight: 700, fontSize: '1rem', color: '#0f172a' }}
                  >
                    Status dos Caixas
                  </Typography>
                  <Typography variant="caption" style={{ color: '#64748b' }}>
                    Saldos atuais e caixas abertos agora
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Divider style={{ marginBottom: 12 }} />

            {cashRegisters.length > 0 ? (
              cashRegisters.map((cr) => (
                <Box
                  key={cr.id}
                  p={1.5}
                  mb={1}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  style={{
                    borderRadius: 8,
                    backgroundColor: cr.isOpen ? '#f0fdf4' : '#f8fafc',
                    border: `1px solid ${cr.isOpen ? '#bbf7d0' : '#e2e8f0'}`,
                  }}
                >
                  <Box>
                    <Typography
                      variant="body2"
                      style={{ fontWeight: 700, color: '#0f172a' }}
                    >
                      {cr.name}
                    </Typography>
                    <Chip
                      size="small"
                      label={cr.isOpen ? 'ABERTO' : 'FECHADO'}
                      style={{
                        height: 18,
                        fontSize: '0.65rem',
                        fontWeight: 700,
                        marginTop: 4,
                        backgroundColor: cr.isOpen ? '#16a34a' : '#94a3b8',
                        color: '#fff',
                      }}
                    />
                  </Box>

                  <Box textAlign="right">
                    <Typography variant="caption" style={{ color: '#64748b', display: 'block' }}>
                      Saldo atual
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      style={{ fontWeight: 800, color: '#0f172a' }}
                    >
                      {formattedCurrency(cr.currentValue)}
                    </Typography>
                  </Box>
                </Box>
              ))
            ) : (
              <Box py={4} textAlign="center" style={{ color: '#94a3b8' }}>
                <Typography variant="body2">Nenhum caixa ativo encontrado.</Typography>
              </Box>
            )}
          </Box>

          <Box mt={1} display="flex" justifyContent="flex-end">
            <Button
              size="small"
              color="primary"
              endIcon={<ArrowForward fontSize="small" />}
              onClick={() => history.push('/home/caixas/pesquisar')}
              style={{ textTransform: 'none', fontWeight: 700 }}
            >
              Gerenciar caixas
            </Button>
          </Box>
        </Paper>
      </Grid>

      {/* Coluna 2: Agenda de Hoje & Contas a Pagar */}
      <Grid item xs={12} md={4}>
        <Paper
          elevation={0}
          style={{
            padding: 20,
            borderRadius: 10,
            border: '1px solid #e2e8f0',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <Box>
            <Box display="flex" alignItems="center" mb={1.5}>
              <EventNote style={{ color: '#7c3aed', marginRight: 8 }} />
              <Box>
                <Typography
                  variant="h6"
                  style={{ fontWeight: 700, fontSize: '1rem', color: '#0f172a' }}
                >
                  Compromissos & Contas do Dia
                </Typography>
                <Typography variant="caption" style={{ color: '#64748b' }}>
                  Contas vencendo/atrasadas e agenda de hoje
                </Typography>
              </Box>
            </Box>

            <Divider style={{ marginBottom: 12 }} />

            <Box mb={2}>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={1}
              >
                <Typography
                  variant="caption"
                  style={{
                    fontWeight: 700,
                    color: '#475569',
                    textTransform: 'uppercase',
                  }}
                >
                  Contas a Pagar ({billItems.length})
                </Typography>
                {dueBills.overdueCount > 0 && (
                  <Chip
                    size="small"
                    label={`${dueBills.overdueCount} atrasada(s)`}
                    style={{
                      height: 18,
                      fontSize: '0.65rem',
                      fontWeight: 700,
                      backgroundColor: '#fee2e2',
                      color: '#b91c1c',
                    }}
                  />
                )}
              </Box>

              {billItems.length > 0 ? (
                billItems.slice(0, 3).map((b) => (
                  <Box
                    key={b.id}
                    py={0.75}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    style={{ borderBottom: '1px solid #f1f5f9' }}
                  >
                    <Box minWidth={0} pr={1}>
                      <Typography
                        variant="body2"
                        noWrap
                        style={{ fontWeight: 600, color: '#0f172a', fontSize: '0.82rem' }}
                      >
                        {b.name}
                      </Typography>
                      <Typography
                        variant="caption"
                        style={{
                          color: b.isOverdue ? '#dc2626' : '#d97706',
                          fontWeight: 600,
                        }}
                      >
                        {b.isOverdue
                          ? `Venceu em ${b.dueDateFormatted}`
                          : 'Vence hoje'}
                      </Typography>
                    </Box>
                    <Typography
                      variant="body2"
                      style={{ fontWeight: 700, color: '#0f172a', flexShrink: 0 }}
                    >
                      {formattedCurrency(b.value)}
                    </Typography>
                  </Box>
                ))
              ) : (
                <Typography variant="caption" style={{ color: '#94a3b8', display: 'block' }}>
                  Nenhuma conta pendente para hoje ou em atraso.
                </Typography>
              )}
            </Box>

            <Box>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={1}
              >
                <Typography
                  variant="caption"
                  style={{
                    fontWeight: 700,
                    color: '#475569',
                    textTransform: 'uppercase',
                  }}
                >
                  Agenda de Hoje ({todaySchedules.total || 0})
                </Typography>
                {todaySchedules.pending > 0 && (
                  <Chip
                    size="small"
                    label={`${todaySchedules.pending} pendente(s)`}
                    style={{
                      height: 18,
                      fontSize: '0.65rem',
                      fontWeight: 700,
                      backgroundColor: '#ede9fe',
                      color: '#6d28d9',
                    }}
                  />
                )}
              </Box>

              {scheduleItems.length > 0 ? (
                scheduleItems.slice(0, 3).map((sch) => (
                  <Box
                    key={sch.id}
                    py={0.75}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    style={{ borderBottom: '1px solid #f1f5f9' }}
                  >
                    <Box display="flex" alignItems="center" minWidth={0} pr={1}>
                      <Chip
                        size="small"
                        label={sch.time || '--:--'}
                        style={{
                          height: 20,
                          fontSize: '0.7rem',
                          fontWeight: 700,
                          marginRight: 8,
                          backgroundColor: '#f1f5f9',
                          color: '#0f172a',
                        }}
                      />
                      <Typography
                        variant="body2"
                        noWrap
                        style={{ fontWeight: 600, color: '#0f172a', fontSize: '0.82rem' }}
                      >
                        {sch.customerName}
                      </Typography>
                    </Box>
                    <Typography
                      variant="caption"
                      style={{ fontWeight: 700, color: '#475569', flexShrink: 0 }}
                    >
                      {sch.status}
                    </Typography>
                  </Box>
                ))
              ) : (
                <Typography variant="caption" style={{ color: '#94a3b8', display: 'block' }}>
                  Nenhum agendamento marcado para hoje.
                </Typography>
              )}
            </Box>
          </Box>

          <Box mt={1} display="flex" justifyContent="space-between">
            <Button
              size="small"
              color="primary"
              onClick={() => history.push('/home/contas/pagar')}
              style={{ textTransform: 'none', fontWeight: 700 }}
            >
              Ver contas
            </Button>
            <Button
              size="small"
              color="primary"
              endIcon={<ArrowForward fontSize="small" />}
              onClick={() => history.push('/home/agendamentos/agenda')}
              style={{ textTransform: 'none', fontWeight: 700 }}
            >
              Abrir agenda
            </Button>
          </Box>
        </Paper>
      </Grid>

      {/* Coluna 3: Últimas Vendas Realizadas */}
      <Grid item xs={12} md={4}>
        <Paper
          elevation={0}
          style={{
            padding: 20,
            borderRadius: 10,
            border: '1px solid #e2e8f0',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <Box>
            <Box display="flex" alignItems="center" mb={1.5}>
              <Receipt style={{ color: '#10b981', marginRight: 8 }} />
              <Box>
                <Typography
                  variant="h6"
                  style={{ fontWeight: 700, fontSize: '1rem', color: '#0f172a' }}
                >
                  Últimas Vendas do Período
                </Typography>
                <Typography variant="caption" style={{ color: '#64748b' }}>
                  Histórico recente das vendas registradas
                </Typography>
              </Box>
            </Box>

            <Divider style={{ marginBottom: 12 }} />

            {recentSales.length > 0 ? (
              recentSales.slice(0, 5).map((sale) => (
                <Box
                  key={sale.id}
                  py={1}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  style={{ borderBottom: '1px solid #f1f5f9' }}
                >
                  <Box minWidth={0} pr={1}>
                    <Box display="flex" alignItems="center">
                      <Typography
                        variant="body2"
                        noWrap
                        style={{ fontWeight: 700, color: '#0f172a', fontSize: '0.84rem' }}
                      >
                        #{sale.id} • {sale.customerName}
                      </Typography>
                      <Typography
                        variant="caption"
                        style={{ color: '#94a3b8', marginLeft: 6 }}
                      >
                        {sale.time}
                      </Typography>
                    </Box>
                    <Typography
                      variant="caption"
                      noWrap
                      display="block"
                      style={{ color: '#64748b' }}
                    >
                      {sale.itemsSummary}
                    </Typography>
                  </Box>

                  <Box textAlign="right" flexShrink={0}>
                    <Typography
                      variant="body2"
                      style={{ fontWeight: 800, color: '#0f172a' }}
                    >
                      {formattedCurrency(sale.value)}
                    </Typography>
                    <Chip
                      size="small"
                      label={sale.isClosed ? 'Pago' : 'Em aberto'}
                      style={{
                        height: 18,
                        fontSize: '0.65rem',
                        fontWeight: 700,
                        backgroundColor: sale.isClosed ? '#dcfce7' : '#fef3c7',
                        color: sale.isClosed ? '#15803d' : '#b45309',
                      }}
                    />
                  </Box>
                </Box>
              ))
            ) : (
              <Box py={4} textAlign="center" style={{ color: '#94a3b8' }}>
                <Typography variant="body2">
                  Nenhuma venda registrada neste período.
                </Typography>
              </Box>
            )}
          </Box>

          <Box mt={1} display="flex" justifyContent="flex-end">
            <Button
              size="small"
              color="primary"
              endIcon={<ArrowForward fontSize="small" />}
              onClick={() => history.push('/home/venda/pesquisar')}
              style={{ textTransform: 'none', fontWeight: 700 }}
            >
              Ver todas as vendas
            </Button>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default OverviewLiveOperations;
